import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import css from './Gel.css'

const SIZE_CLASSES = {
  xsmall: css.xsmall,
  small: css.small,
  medium: css.medium,
  large: css.large,
}
const COLOR_CLASSES = {
  white: css.white,
  bronze: css.bronze,
  red: css.red,
  blue: css.blue,
  black: css.black,
  gold: css.gold,
}

const Gel = ({ className, size, children, color }) => (
  <div className={classnames(SIZE_CLASSES[size], COLOR_CLASSES[color], className)}>
    <div className={css.gelContent}>{children}</div>
  </div>
)

Gel.propTypes = {
  color: PropTypes.oneOf(['white', 'bronze', 'red', 'blue', 'black', 'gold']),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
}

Gel.defaultProps = {
  size: 'medium',
  color: 'white',
  className: null,
  children: null,
}

export { Gel }
